module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduler__users__user__subpools__meta",
    style: ([{
        'left': _vm.itemBCR.right + 4 + 'px'
      },
      {
        'top': _vm.posTop + 'px'
      }
    ])
  }, [_c('table', [_c('thead', {
    staticClass: "subPools__table__header"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.substitute_hours')) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.difference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.assigned')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.scheduled')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.itemSubPoolDiff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.itemSubPool))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.substituteHours))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cb284f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/SchedulerSubSubstituteHours.vue
// module id = 2035
// module chunks = 1